// ─────────────────────────────────────────────────────────────
// SSE Event Contracts
// Typed events sent from server → browser via Server-Sent Events
// ─────────────────────────────────────────────────────────────
export const SSE_EVENT_TYPES = [
    'ai_thinking', 'ai_complete', 'ai_error',
    'new_comment', 'vote_updated', 'comment_liked', 'comment_edited', 'notification',
    'discussion_updated', 'discussion_enriched', 'content_removed', 'ping', 'connected',
    'dm_thinking', 'dm_message', 'dm_error', 'dm_token',
];
//# sourceMappingURL=sse.contract.js.map